import { FC } from 'react'
import BackgroundBox from '../BackgroundBox'
import PerFlexRow from '../FlexRow'
import { TShirtSize } from '../../util/types'

export interface PerInfoBoxProps {
  scrollX?: boolean
  mb?: TShirtSize
}

export const PerInfoBox: FC<PerInfoBoxProps> = ({ children, scrollX, mb = 'xs' }) => {
  return (
    <BackgroundBox mb={mb} r height="infoBox">
      <PerFlexRow scrollX={scrollX} justify="space-between" align="middle" noWrap className="fullHeight">
        {children}
      </PerFlexRow>
    </BackgroundBox>
  )
}
